import { Component } from '@angular/core';

type ActionTone = 'primary' | 'ghost' | 'light';

interface AdminAction {
  label: string;
  route: string;
  tone?: ActionTone;
}

interface AdminSection {
  key: string;
  badge: string;
  title: string;
  description: string;
  accent?: boolean;
  actions: AdminAction[];
}

interface AdminKpi {
  key: string;
  label: string;
  value: string;
  hint: string;
}

@Component({
  selector: 'app-dashborad',
  templateUrl: './dashborad.component.html',
  styleUrls: ['./dashborad.component.css'],
  standalone: false
})
export class DashboradComponent {
  readonly quickActions: AdminAction[] = [
    { label: 'Creer membre', route: '/utilisateur/admin/ajouter/membre', tone: 'primary' },
    { label: 'Creer partenaire', route: '/utilisateur/admin/ajouter/partenaire', tone: 'primary' },
    { label: 'Creer compte Spay', route: '/utilisateur/admin/ajouter/compte/spay', tone: 'ghost' },
    { label: 'Regles de taxe', route: '/utilisateur/admin/tax-rules', tone: 'light' }
  ];

  readonly focusItems: string[] = [
    'Operations partenaires',
    'Comptes et conformite',
    'Ledger et facturation',
    'Fiscalite'
  ];

  readonly sections: AdminSection[] = [
    {
      key: 'partners',
      badge: 'Partenaires',
      title: 'Gestion partenaires',
      description: 'Ajout de membres, partenaires et provisionnement de comptes Spay.',
      actions: [
        { label: 'Ajouter membre', route: '/utilisateur/admin/ajouter/membre', tone: 'primary' },
        { label: 'Ajouter partenaire', route: '/utilisateur/admin/ajouter/partenaire', tone: 'primary' },
        { label: 'Creer compte Spay', route: '/utilisateur/admin/ajouter/compte/spay', tone: 'ghost' }
      ]
    },
    {
      key: 'accounts',
      badge: 'Comptes',
      title: 'Gestion des comptes',
      description: 'Administration des comptes personnels, professionnels et gestionnaires.',
      actions: [
        { label: 'Comptes personnels', route: '/utilisateur/admin/compte/personel', tone: 'primary' },
        { label: 'Comptes pro', route: '/utilisateur/admin/compte/professionel', tone: 'ghost' },
        { label: 'Gestionnaires', route: '/utilisateur/admin/compte/gestionnaire', tone: 'ghost' }
      ]
    },
    {
      key: 'ledger',
      badge: 'Ledger',
      title: 'Controle financier',
      description: 'Suivi des comptes ledger, transactions, ecarts et depots banque.',
      actions: [
        { label: 'Comptes ledger', route: '/utilisateur/admin/ledger/accounts', tone: 'primary' },
        { label: 'Transactions', route: '/utilisateur/admin/ledger/transactions', tone: 'ghost' },
        { label: 'Ecarts', route: '/utilisateur/admin/ledger/discrepancies', tone: 'ghost' },
        { label: 'Depots banque', route: '/utilisateur/admin/bank/deposits', tone: 'ghost' },
        { label: 'Documentation', route: '/utilisateur/admin/ledger/documentation', tone: 'ghost' }
      ]
    },
    {
      key: 'billing',
      badge: 'Facturation',
      title: 'Factures et fiscalite',
      description: 'Pilotage des factures et des regles de taxe.',
      accent: true,
      actions: [
        { label: 'Factures', route: '/utilisateur/admin/billing/invoices', tone: 'primary' },
        { label: 'Regles taxe', route: '/utilisateur/admin/tax-rules', tone: 'light' }
      ]
    }
  ];

  private readonly sectionActionCount = this.sections.reduce((count, section) => count + section.actions.length, 0);

  readonly kpis: AdminKpi[] = [
    {
      key: 'modules',
      label: 'Modules',
      value: String(this.sections.length),
      hint: 'Parcours metiers'
    },
    {
      key: 'cta',
      label: 'CTA visibles',
      value: String(this.quickActions.length + this.sectionActionCount),
      hint: 'Tous conserves'
    },
    {
      key: 'axes',
      label: 'Axes',
      value: String(this.focusItems.length),
      hint: 'Priorites admin'
    }
  ];

  trackSection(_: number, section: AdminSection): string {
    return section.key;
  }

  trackAction(_: number, action: AdminAction): string {
    return `${action.label}-${action.route}`;
  }

  trackKpi(_: number, kpi: AdminKpi): string {
    return kpi.key;
  }
}
